/** English (default) — nested keys for i18next (`t('header.title')`). */
export const en = {
  header: {
    brandAlt: 'Avatar',
    title: 'Chat with Avatar',
    subtitle: 'Ask, discover, or get help instantly',
    reset: 'Reset conversation',
  },
  chat: {
    greeting: 'Hello, how can I help you?',
    typing: 'Avatar is typing…',
    errorFallback: 'Something went wrong. Please try again.',
    retry: 'Try again',
    streamingPlaceholder: '…',
  },
  input: {
    placeholder: 'Ask anything...',
    ariaLabel: 'Message Avatar',
    send: 'Send message',
    poweredBy: 'Powered by Avatar.inc',
  },
  popular: {
    ariaLabel: 'Suggested questions',
    q1: 'What is Zetrix Avatar?',
    q2: 'How do I create an avatar?',
    q3: 'What can my avatar do?',
    q4: 'How do I get started?',
  },
  doc: {
    title: 'Avatar Widget',
  },
} as const;

/** Same tree as `en`, but values are plain strings (other locales). */
export type EnTranslation = {
  [K in keyof typeof en]: {
    [P in keyof (typeof en)[K]]: string;
  };
};
